import React, { forwardRef } from 'react'
import { useDeskStyles } from './pageContainer.styles'
import { Container } from '@material-ui/core'
import clsx from 'clsx'
import PropTypes from 'prop-types'

const PageContainerDesktop = forwardRef((props, ref) => {
  const {
    className,
    headerProps = {},
    customHeader,
    disablePaddings = false,
    ...other
  } = props
  const classes = useDeskStyles()
  return (
    <Container
      className={clsx(!disablePaddings && classes.root, className)}
      ref={ref}
      maxWidth={props?.maxWidth ? props?.maxWidth : 'xl'}
      {...other}
    >
      {React.isValidElement(customHeader) ? customHeader : <></>}
      {other.children}
    </Container>
  )
})
export default PageContainerDesktop

PageContainerDesktop.propTypes = {
  headerProps: PropTypes.shape({
    rightComponent: PropTypes.node
  }),
  customHeader: PropTypes.node
}
